
export const multipleTripConstants = {

    PROCESS_MULTIPLE_TRIP_REQUEST: 'PROCESS_MULTIPLE_TRIP_REQUEST',
    PROCESS_MULTIPLE_TRIP_SUCCESS: 'PROCESS_MULTIPLE_TRIP_SUCCESS',
    PROCESS_MULTIPLE_TRIP_FAILURE: 'PROCESS_MULTIPLE_TRIP_FAILURE',

    PROCESS_MULTIPLE_TRIP_RETURN_REQUEST: 'PROCESS_MULTIPLE_TRIP_RETURN_REQUEST',
    PROCESS_MULTIPLE_TRIP_RETURN_SUCCESS: 'PROCESS_MULTIPLE_TRIP_RETURN_SUCCESS',
    PROCESS_MULTIPLE_TRIP_RETURN_FAILURE: 'PROCESS_MULTIPLE_TRIP_RETURN_FAILURE',

    PROCESS_MULTIPLE_TRIP_RETRY_REQUEST: 'PROCESS_MULTIPLE_TRIP_RETRY:REQUEST',
    PROCESS_MULTIPLE_TRIP_RETRY_SUCCESS: 'PROCESS_MULTIPLE_TRIP_RETRY:SUCCESS',
    PROCESS_MULTIPLE_TRIP_RETRY_FAILURE: 'PROCESS_MULTIPLE_TRIP_RETRY:FAILURE',

    CANCEL_TRIP_REQUEST: 'CANCEL_TRIP_PLANNED_REQUEST',
    CANCEL_TRIP_FAILURE: 'CANCEL_TRIP_PLANNED_FAILURE',

    OPEN_MODAL_SELECT_FREQUENCY: 'OPEN_MODAL_SELECT_FREQUENCY',

    GET_TRIPS_MULTIPLE_REQUEST: 'GET_TRIPS_MULTIPLE_REQUEST',
    GET_TRIPS_MULTIPLE_SUCCESS: 'GET_TRIPS_MULTIPLE_SUCCESS',
    GET_TRIPS_MULTIPLE_FAILURE: 'GET_TRIPS_MULTIPLE_FAILURE',

    SHOW_MODAL_DETAILS: 'SHOW_MODAL_DETAILS',
    UPDATE_LIST_TRIPS: 'UPDATE_LIST_TRIPS',
    SET_TRIP_ID_PLAN: 'SET_TRIP_ID_PLAN',

    UPDATE_SELECTED_TRIPS: 'UPDATE_SELECTED_TRIPS',
    UPDATE_SCHEDULE_RETURN_PROCESS: 'UPDATE_SCHEDULE_RETURN_PROCESS',

    UPDATE_TRIPS_TO_LIST_EXIST: "UPDATE_TRIPS_TO_LIST_EXIST",
    SET_PREVIEW_TRIP: 'SET_PREVIEW_TRIP',

    SET_ORIGINAL_OUTBOUND_TRIP: 'SET_ORIGINAL_OUTBOUND_TRIP',
    SET_ORIGINAL_RETURN_TRIP: 'SET_ORIGINAL_RETURN_TRIP',

    CLEAN_MULTIPLE_TRIPS: 'CLEAN_MULTIPLE_TRIPS',
    CLEAN_RESULTS: 'CLEAN_RESULTS'
}